import React, { useCallback, useEffect, useState } from "react";

import { CustomerSucessController } from "@talentbait/shared-components";

import * as SC from "./MediaAssets.styled";

import { MediaLibraryStore, PreviewStore, withRefluxStore } from "../../../../Stores";

import MediaWidget from "./media-widget/MediaWidget";
import AssetsUpload from "./assets-upload/AssetsUpload";
import RightSideBar from "../right-sidebar/RightSideBar";
import Actions from "../../../../Actions";
import logger from "../../../../utils/LoggerFrontend";

const STEP_PREVIEWS_NEW = "STEP_PREVIEWS_NEW";

const MediaAssets = ({
  currentStep,
  // Store
  companyLogo,
  campaignData,
  recentLogos,
  userProfile,
  posts,
  selectedPostData,
  loadingRecent
}) => {
  const [availableLogos, setAvailableLogos] = useState([]);
  const [defaultTalentbaitLogo, setDefaultTalentbaitLogo] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState(selectedPostData?.logo);
  const logoWarningAdKey = "logoWarning";

  useEffect(() => {
    if (!selectedLogo && !defaultTalentbaitLogo) {
      return Actions.setAdErrors({
        inputKey: logoWarningAdKey,
        hasError: false,
        errorMessage: `Die Auswahl eines Logos ist nicht obligatorisch.`
      });
    }

    return Actions.removeAdErrors(logoWarningAdKey);
  }, [selectedLogo, defaultTalentbaitLogo]);

  useEffect(() => {
    if (selectedPostData) {
      setSelectedLogo(selectedPostData?.logo);
    }
  }, [selectedPostData]);

  const processLogos = useCallback((uploadedPhotos) => {
    if (uploadedPhotos) {
      const availableLogos = uploadedPhotos
        .filter((item) => item.context?.type === "logo")
        .map((item) => item?.image_url);

      setAvailableLogos(availableLogos);
    }
  }, []);

  useEffect(() => {
    processLogos(recentLogos);
  }, [recentLogos, processLogos]);

  const logosWithCompany = companyLogo ? availableLogos.concat(companyLogo) : availableLogos;

  // Handle logo selection for all channels and posts for now
  const handleLogoSelection = async (logoURL) => {
    const eventProperties = {
      logoURL,
      organizationId: campaignData.organizationId
    };

    Actions.addNotification("Das Logo wurde aktualisiert!");
    CustomerSucessController.send(`Logo Selected - Campaign Creation`, eventProperties);

    for (const [channelName, channelPosts] of Object.entries(posts)) {
      for (const post of channelPosts) {
        logger.log("info:MediaAssets:handleLogoSelection", "Updating post with logo", {
          channelName,
          post
        });

        const { channel, postNumber, campaignId } = post;
        const { userName } = userProfile;

        await Actions.updatePost({
          channelShortName: channel,
          postNumber,
          isReleased: false,
          userName,
          updateData: { logo: logoURL },
          campaignId
        });
      }
    }
  };

  if (currentStep === STEP_PREVIEWS_NEW) {
    return (
      <SC.MediaAssetsWrapper>
        <MediaWidget title={"Logos"}>
          <AssetsUpload
            isLogo
            src={logosWithCompany}
            selectedAsset={selectedLogo}
            campaignData={campaignData}
            handleLogoSelection={handleLogoSelection}
            handleNewImageUpload={(url) => setAvailableLogos([...availableLogos, url])}
            isLoading={loadingRecent}
          />
          {!selectedLogo && (
            <SC.AssetAttentionBox>
              <section>
                Ein Logo ist für Kampagnen erforderlich. Ohne Auswahl wird das Talentbait-Logo
                verwendet.
              </section>
              <SC.ToggleWrapper>
                <SC.Toggle
                  checked={defaultTalentbaitLogo}
                  onChange={setDefaultTalentbaitLogo}
                  defaultTalentbaitLogo={defaultTalentbaitLogo}
                />
                Ich akzeptiere das Talentbait-Logo.
              </SC.ToggleWrapper>
            </SC.AssetAttentionBox>
          )}
        </MediaWidget>
        <RightSideBar currentStep={currentStep} mediaAsset={true} />
      </SC.MediaAssetsWrapper>
    );
  }
  return <></>;
};

export default withRefluxStore(
  MediaAssets,
  [PreviewStore, MediaLibraryStore],
  [
    "companyLogo",
    "campaignData",
    "recentLogos",
    "userProfile",
    "posts",
    "selectedPostData",
    "loading",
    "loadingRecent"
  ]
);
